
export const styles = () => ({
  check: {
    margin: 1
  }
});

export default styles;
